import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';

class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.location.state.user);
        this.state = {
            user: props.location.state.user,
            input: {
                targetEmail: '',
                locationIDs:'',
                sNote: '',
                bInclude: true
            },
            errors: {},
            loading: false
        };

        this.saveLocationFilter = this.saveLocationFilter.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.verifyEmail = this.verifyEmail.bind(this);
        this.OptionChange = this.OptionChange.bind(this);
    }

    componentDidMount() {
        //document.getElementById('radInclude').checked = this.state.input.bInclude;
    }


    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        input[event.target.name] = event.target.value;
        this.setState({
            input,
            errors
        });
    }

    validate(event) {

        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["targetEmail"]) {
            isValid = false;
            errors["targetEmail"] = "Please enter user email.";
        }
        if (!input["locationIDs"]) {
            isValid = false;
            errors["locationIDs"] = "Please enter location ID.";
        }

        if (!input["targetEmail"] || !String(input["targetEmail"])
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
            isValid = false;
            errors["targetEmail"] = "Invalid email address.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    verifyEmail() {
        if (!this.state.input['targetEmail']
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            alert('Invalid email, please check the email format and try again.');
            return;
        }
        axios.get(`${Constants.apiURL}/api/Identity/VerifyLocationUserEmail`, {
            params: {
                email: this.state.input.targetEmail
            }
        }).then(response => {
            console.log(response);
            if (response.status == 200) {
                let a = response.data;
                this.setState({
                    intput:
                    {
                        locationIDs: a.locationIDs,
                        email: a.email,
                        bInclude: a.isInclude
                    }
                });
                this.state.input.bInclude = a.isInclude;
                this.state.input.locationIDs = a.locationIDs.trim();
                this.state.input.targetEmail = a.email.trim();
                this.state.input.sNote = a.notes.trim();
                alert(this.state.input.targetEmail+ ': '+ this.state.input.locationIDs + ' exists.');

            }
            else {
                alert(this.state.input.targetEmail + ' not found.');
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert('Unable verify email');
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert('Error contacting server. Please try again soon.')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }

    OptionChange(event) {
        //alert(event.target.value + '/' + event.target.checked);
        this.setState({
            input:
            {
                bInclude: document.getElementById('radInclude').checked == true,
            }
        });
    }

    saveLocationFilter() {
        axios.get(`${Constants.apiURL}/api/Identity/SaveLocationFilter`, {
            params: {
                email: document.getElementById('txtTargetEmail').value, //this.state.input.targetEmail,
                locationIDs: document.getElementById('txtLocationIDs').value,
                bInclude: this.state.input.bInclude,
                sNote: document.getElementById('txtNotes').value
            }
        }).then(response => {
            if (response.status == 200) {
                alert('location saved');
            }
            else {
                alert("error:Save location filter");
            }
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                alert(error.message)
          } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }


    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='locationFilter' />
                <Form onSubmit={this.handleSubmit} noValidate >
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '800px' }} className="mb-3">
                        <Col md={6}>
                            <Form.Label style={{ paddingBottom: '24px' }} className="form-header">Configure Location Filter for User</Form.Label>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Group as={Row}>
                                    <Col md={10}>
                                <Form.Control id="txtTargetEmail" type="targetEmail" placeholder="Enter user email and verify" name="targetEmail"  onChange={this.handleFormChange} required isInvalid={!!this.state.errors.email} />
                                    </Col>
                                    <Button className="mobile-m-t-10 mobile-m-l-10" style={{ width: 'auto' }} onClick={ this.verifyEmail }>Verify</Button>
                                    
                                </Form.Group>
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.email}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formLocationIDs">
                                <Form.Label>Location IDs</Form.Label>
                                <Form.Control id="txtLocationIDs" type="input" placeholder="Enter location ID, separated by comma. " name="locationIDs" value={this.state.input.locationIDs} onChange={this.handleFormChange} />
                                <input type="radio" name="options" id="radInclude" checked={this.state.input.bInclude} onChange={this.OptionChange} />&nbsp;Include&nbsp;&nbsp;&nbsp;
                                <input type="radio" name="options" id="radExclude" checked={!this.state.input.bInclude} onChange={this.OptionChange} />&nbsp;Exclude

                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formNotes">
                                <Form.Label>Notes</Form.Label>
                                <Form.Control id="txtNotes" type="text" placeholder="Enter notes or leave blank." name="sNote" value={this.state.input.sNote} onChange={this.handleFormChange} required
                                    isInvalid={!!this.state.errors.phonenumber} />
                                <Form.Control.Feedback type='invalid'>
                                    {this.state.errors.Notes}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" onClick={this.saveLocationFilter} >Save</Button>
                </Form>
            </div>
        );
    }
}

export default UserSettings;
